import axios from 'axios'
import { getToken, removeToken } from '@/store/local/auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // API 基础路径
  withCredentials: true, // 跨域请求时发送 cookie
  timeout: 600000, // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    console.log(error) // 打印错误信息用于调试
    return Promise.reject('失败'+error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response
    if (res.status != 200) {
      if (res.status == 403) {
        // 移除了 MessageBox.confirm 弹窗
        removeToken()
        location.reload()
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      if (res.data.code == 0) {
        // 移除了 Message 提示
      }
      return res
    }
  },
  error => {
    console.log('err' + error) // 打印错误信息用于调试
    // 移除了 Message 提示
    return Promise.reject(error)
  }
)

export default service